import TileLayer from "ol/layer/Tile";
import TileWMS from "ol/source/TileWMS";
import { useContext, useEffect, useState } from "react";
import { useAppSelector } from "../../../../store/hooks";
import MapContext from "../MapContext";

interface ILayerConf {
    name: string;
    opacity: number;
    labeling?: number
}
interface TileLayerConfig {
    url: string;
    layername: ILayerConf[];
    isLegendActive: boolean;
    serviceType?: string;
    style?: string;
    refresh?: string;
}

export default function OlTileLayer(props: TileLayerConfig) {

    const { url, layername, isLegendActive, serviceType, style, refresh } = props;

    const map = useContext(MapContext)
    const [tile, setTile] = useState<TileLayer<TileWMS>>()
    const token = useAppSelector(state => state.authState.token)

    useEffect(() => {

        const tilelayer = new TileLayer({
            zIndex: 100,
            visible: false,
            source: new TileWMS({
                crossOrigin: "anonymous",
                url: url + '/wms',
                params: { 'LAYERS': layername.map(obj => obj.name).reverse().join(','), 'TILED': true, 'STYLES': layername.map(layer => layer.name === 'parsel_usr' ? style : '').reverse().join(',') },
                serverType: 'geoserver',
            }),
        })

        if (serviceType === 'VECTOR') {
            tilelayer.set('infoLayer', true);
        }
        setTile(tilelayer);
        map.addLayer(tilelayer);

        return () => {
            if (tile) {
                map.removeLayer(tile);
            }
        }
    }, [])

    useEffect(() => {
        if (layername.length > 0) {
            tile?.getSource()?.clear();
            tile?.getSource()?.updateParams({
                'env': layername.map(obj => { return `opacity_${obj.name}:${obj.opacity}` }).reverse().join(';') + ';' + layername.map(obj => { return `labeling_${obj.name}:${obj.labeling}` }).join(';'),
                'LAYERS': layername.map(obj => obj.name).reverse().join(','), 'TILED': true, 'STYLES': layername.map(layer => layer.name === 'parsel_usr' ? style : '').reverse().join(','),
                'token': token
            });
            tile?.setVisible(true);

        } else {
            tile?.setVisible(false);
        }
    }, [layername, style])

    useEffect(() => {
        tile?.getSource()?.refresh();
    }, [refresh])

    return (
        <>
            {
                isLegendActive && layername.length > 0 &&
                <img style={{ borderRadius: '5px', border: '2px solid var(--primary-color)', position: 'absolute', left: '10px', bottom: '95px' }}
                    src={`${url}/wms?REQUEST=GetLegendGraphic&VERSION=1.1.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&LAYER=${layername[0].name}&LEGEND_OPTIONS=bgColor:0xd8d8d8;fontAntiAliasing:true;labelMargin:5;dpi:120;`} />
            }
        </>
    )
}
